import {
  brandEntityId,
  BrandEntityId,
  brandOverlayDataFile,
  BrandOverlayDataFile,
  brandOverlayDataHeight,
  BrandOverlayDataHeight,
  brandOverlayDataWidth,
  BrandOverlayDataWidth,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlayCreateRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlayCreateRequestDTO.validationSchema()
  );

  constructor(readonly data: RoomBrandOverlayCreateRequest) {
    JsonSchemaValidator.assert(
      RoomBrandOverlayCreateRequestDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandId", "data", "width", "height"],
      properties: {
        roomId,
        brandId: brandEntityId,
        data: brandOverlayDataFile,
        width: brandOverlayDataWidth,
        height: brandOverlayDataHeight
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandOverlayCreateRequest {
  roomId: RoomId;
  brandId: BrandEntityId;
  data: BrandOverlayDataFile;
  width: BrandOverlayDataWidth;
  height: BrandOverlayDataHeight;
}
